<template>
  <div>
    <h3 class="mt-3 mb-4 mk-businesstradesummary">Trading Summary</h3>
    <hr />

    <div class="row">
      <div class="col-6 mw-200">
        <p>Limit</p>
      </div>
      <div class="col-6">
        <p>{{initial_business.dollar_finance_capacity.formatted}}</p>
      </div>
    </div>

    <div class="row">
      <div class="col-6 mw-200">
        <p>Drawn</p>
      </div>
      <div class="col-6">
        <p>{{initial_business.amount_outstanding.formatted}}</p>
      </div>
    </div>

    <div class="row">
      <div class="col-6 mw-200">
        <p>Available</p>
      </div>
      <div class="col-6">
        <p>{{initial_business.dollar_available_capacity.formatted}}</p>
      </div>
    </div>

    <div class="row">
      <div class="col-6 mw-200">
        <p>Trades This Year</p>
      </div>
      <div class="col-6">
        <p>{{initial_business.trades_this_year}}</p>
      </div>
    </div>

    <div class="row">
      <div class="col-6 mw-200">
        <p>Open Trades</p>
      </div>
      <div class="col-6">
        <p>{{initial_business.open_trades}}</p>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <hr />
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <p><strong>Bank Details</strong></p>
      </div>
    </div>
    <div class="row">
      <div class="col-6 mb-2 mw-200">
        Closed Capital Total
        <br />
        <small>As of {{moment.utc(initial_business.updated_at, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')}}</small>
      </div>
      <div class="col-6">{{initial_business.closed_capital_total}}</div>
    </div>

    <div class="row">
      <div class="col-6 mw-200">Re-evaluation Required</div>
      <div
        class="col-6"
      >{{initial_business.evaluate_at ? moment.utc(initial_business.evaluate_at, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss') : 'N/A'}}</div>
    </div>


  </div>
</template>
<script>
export default {
    props: {
        initial_business:{
            type: Object
        }
    },
    data() {
        return {
            //
        }
    }
}
</script>
